import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { CareType } from 'src/app/models/care-type.model'
import { CodeListService } from './CodeListService'

@Injectable({
  providedIn: 'root',
})
export class CareTypeService extends CodeListService<CareType> {
  recordClass = CareType

  constructor() {
    super()
  }

  getForSocialServiceType(socialServiceTypeId: number): Observable<CareType[]> {
    return this.feathers.find(CareType, { socialServiceTypeId })
  }
}
